import axios from "axios";
import appConfig from "./config/app.config";
import { ACCESS_TOKEN } from "./constants/app.constants";

const _axios = axios.create();

_axios.CancelToken = axios.CancelToken;
_axios.isCancel = axios.isCancel;

_axios.interceptors.request.use(
  (request) => {
    const accessToken = localStorage.getItem(ACCESS_TOKEN);
    const apiKey = process.env.REACT_APP_API_KEY;
    request.headers['Access-Control-Allow-Origin'] = "*";
    if (accessToken && !request.headers["Authorization"]) {
      request.headers["Authorization"] = `Bearer ${accessToken}`;
      
    }
    if (apiKey && !request.headers["api-key"]) {
      request.headers["api-key"] = apiKey;
      
    }
    return request;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  }
);

_axios.interceptors.response.use(
  (res) => {
    return res;
  }
  ,
  (error) => {
   if (error.response?.status === 401 || error.response?.status === 403 || error.code === "ECONNABORTED" || error.response?.data.message === "401 Unauthorized: [no body]") {
      if (localStorage.getItem(ACCESS_TOKEN) !== null) {
        localStorage.removeItem(ACCESS_TOKEN);
      }
      if (localStorage.getItem(ACCESS_TOKEN) !== null) {
        localStorage.removeItem(REFRESH_TOKEN);
      }
      return Promise.reject(error);
      
    }
    return Promise.reject(error);
  }
);

const useRestApiCall = () => {
  const apiCall = (payload) => {
    const apiPayload = {
      // `url` is the server URL
      url: payload.url || "",
      // `method` is the request method
      method: payload.method || "GET",
      // `baseURL` will be prepended to `url` unless `url` is absolute.
      baseURL: payload.baseURL || "",
      // `headers` are custom headers to be sent
      headers: payload.headers || {},
      // `params` are the URL parameters to be sent with the request
      params: payload.params || {},
      // `data` is the data to be sent as the request body
      data: payload.data || {},
      config: payload.config || {},
      form: payload.form || {},
      
      responseType: payload.responseType,
      cancelToken: payload.cancelToken,
      onUploadProgress: payload.onUploadProgress,
    };

    return new Promise(function (resolve, reject) {
      _axios(apiPayload)
        .then((data) => {
          console.log(data);
          resolve(data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
  return { apiCall };
};

export const generateCancelToken = () => _axios.CancelToken.source();

export const isRequestCancelled = (error) => _axios.isCancel(error);

export default useRestApiCall;
